import { Component, Event, EventEmitter, h, Host, Prop } from "@stencil/core";
import { addToInquiry } from "@stores/inquiry.store";
import {
  BcpAddToInquiryProps,
  ProductAddedToInquiryEventDetails,
} from "./bcp-add-to-inquiry-model";
import { ButtonProps } from "../../frontend-kit/atoms/f-button/f-button-model";

@Component({
  tag: "bcp-add-to-inquiry",
})
export class BcpAddToInquiry {
  @Prop() buttonLabel: BcpAddToInquiryProps["buttonLabel"] = "Add to inquiry";

  @Prop() productCode: BcpAddToInquiryProps["productCode"];

  @Prop() quantity: BcpAddToInquiryProps["quantity"] = 1;

  @Prop() buttonVariant: ButtonProps["variant"] = "primary";

  @Event()
  productAddedToInquiry: EventEmitter<ProductAddedToInquiryEventDetails>;

  private handleAddToInquiryButton = async () => {
    await addToInquiry(this.productCode, this.quantity).then((inquiryCart) =>
      this.productAddedToInquiry.emit({
        productCode: this.productCode,
        inquiryCode: inquiryCart.code,
      })
    );
  };

  render() {
    return (
      <Host>
        <f-button
          fullWidth={true}
          onClick={this.handleAddToInquiryButton}
          variant={this.buttonVariant}
        >
          <f-icon iconName="post-it" titleText={this.buttonLabel} />
          <span>{this.buttonLabel}</span>
        </f-button>
      </Host>
    );
  }
}
